import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FocusInputType, LocalService, NumericConfig } from '../../../service/local.service';

@Component({
  selector: 'app-mapping-container',
  templateUrl: './mapping-container.component.html',
  styleUrls: ['./mapping-container.component.scss']
})
export class MappingContainerComponent implements OnInit {
  @Input() Title = 'Mapping';
  @Input() MaxLines: number = 5;
  @Input() items: any;
  itemsLocal: any = [];
  @Input() isOnlyNumbers = false;
  @Input() isGrouping = false;
  @Input() isDecimalAllowed = false;
  @Input() isNegativeAllowed = false;
  @Input() isStartWithZero = false;
  @Input() isFocusInput = false;
  @Input() isEnableDeleteOption = false;
  @Input() maximumDigits = 15;
  @Input() maxValue: number | null = null;
  @Output() onValuesUpdated = new EventEmitter();
  @Output() itemsChange = new EventEmitter<any>();

  numericConfig: NumericConfig;
  htmlId: string = ''; elementIds: any;
  constructor(public localService: LocalService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      txt_value: 'txt_value_' + this.htmlId + '_'
    }
  }

  ngOnInit(): void {
    this.numericConfig = { isDecimalAllowed: this.isDecimalAllowed, maxValue: this.maxValue, maximumDigits: this.maximumDigits, isNegativeAllowed: this.isNegativeAllowed, isStartWithZeroAllowed: this.isStartWithZero } as NumericConfig;

    this.onLoad(true);
  }

  ngOnChanges(): void {
  }

  onLoad(isOnLoad = false) {
    if (isOnLoad) {
      this.itemsLocal = [];
      if (this.items != undefined && this.items != null && this.items.length > 0) {
        this.items.forEach(x => {
          this.itemsLocal.push({ value: x });
        });
      }
    }
    this.onLoadEmptyContainer();
    if (isOnLoad) {
      this.setFocus();
    }
  }

  onLoadEmptyContainer() {
    if (this.itemsLocal && this.itemsLocal.length > 0) {
      if (this.itemsLocal.filter(x => (this.isOnlyNumbers ? x.value == null : x.value.trim() == '')).length > 1) {
        this.itemsLocal = this.itemsLocal.filter(x => (this.isOnlyNumbers ? x.value != null : x.value.trim() != ''));
      }
      if (this.itemsLocal.length != this.MaxLines && this.itemsLocal.filter(x => (this.isOnlyNumbers ? x.value == null : x.value.trim() == '')).length == 0) {
        this.itemsLocal.push({ value: this.isOnlyNumbers ? null : '' });
      }
    } else {
      this.itemsLocal = [];
      this.itemsLocal.push({ value: this.isOnlyNumbers ? null : '' });
    }

    if (this.itemsLocal.length == 1) {
      this.setFocus();
    }
  }

  onInput(value: string) {
    this.onLoadEmptyContainer();
    if (!(value && value.toString().trim().length > 0)) {
      this.setFocus();
    }
  }

  onDelete(index: number) {
    this.itemsLocal.splice(index, 1);
    if (this.itemsLocal.length == 0) {
      this.onLoadEmptyContainer();
    } else {
      this.setFocus();
    }
  }

  setFocus() {
    if (this.isFocusInput) {
      this.localService.onFocusNextInput(this.elementIds.txt_value + (this.itemsLocal.length - 1), FocusInputType.TextBox);
    }
  }

  onFocusOut() {
    this.items = [];
    this.itemsLocal.forEach(x => {
      let value = this.isOnlyNumbers ? x.value : x.value.trim();
      if (value != '')
        this.items.push(value);
    });
    this.onValuesUpdated.emit(this.items);
  }
}
